import React, { useEffect } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import Loader from 'components/Loader/Loader';
import { push } from 'connected-react-router';
import Sidebar from 'components/Sidebar/Sidebar';
import { scrollMainToTop } from 'utils/helpers';
import DashboardContent from '../components/Dashboard/DashboardContent/DashboardContent';
import HelpCenter from '../components/Dashboard/HelpCenter/HelpCenter';
import DemoLauncher from '../components/Dashboard/DemoLauncher/DemoLauncher';
import { useOrganization } from 'contexts/OrganizationsContext';
import { AppState } from 'reducers/reducers';

type MainViewProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const MainView = ({ push: connectedPush, isSuperuser }: MainViewProps): JSX.Element => {
    const { organizations } = useOrganization();
    const helpCenterRouteMatch = useRouteMatch('/help-center');

    useEffect(() => {
        // Superusers stay on the landing page so the org/spot search and demo
        // launcher remain available — auto-redirecting to the first org unmounts
        // the sidebar and wipes whatever they've typed into the search field.
        if (isSuperuser) return;
        if (organizations?.[0] && !helpCenterRouteMatch) {
            connectedPush(`/organization/${organizations[0].pk}`);
            scrollMainToTop();
        }
    }, [organizations, connectedPush, helpCenterRouteMatch, isSuperuser]);

    const renderRoot = () => {
        if (isSuperuser) {
            return <DemoLauncher />;
        }
        if (organizations) {
            return <Loader />;
        }
        return null;
    };

    return (
        <Sidebar>
            <Route path="/help-center">
                <DashboardContent title={'Help Center'}>
                    <HelpCenter />
                </DashboardContent>
            </Route>
            <Route exact path="/">
                {renderRoot()}
            </Route>
        </Sidebar>
    );
};

function mapStateToProps(state: AppState) {
    return {
        isSuperuser: state.auth.profile?.superuser ?? false,
    };
}

const mapDispatchToProps = {
    push,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainView);
